export default __webpack_public_path__ + "static/progress_logo-7201ce5baf6bc156d55009028b6adc18.svg";